<template>
  <router-view />
</template>

<script>
export default {
  name: 'store-highlights-pages-container',
};
</script>
